export const IMAGE_FILE_TYPES = [
  'image/avif', '.avif',
  'image/gif', '.gif',
  'image/heic', 'image/heif', '.heic', '.heif',
  'image/jpeg', '.jpg',
  'image/png', '.png',
  'image/tiff', '.tiff'
]

export const CSV_FILE_TYPES = [
  'text/csv', '.csv'
]

export const GEOGRAPHIES_FILE_TYPES = [
  'application/vnd.google-earth.kml+xml', '.kml',
  'application/vnd.google-earth.kmz', '.kmz'
]
